import { useEffect, useState } from 'react';

import Spinner from '../../../../reusable/spinner/spinner.component';
import Client from '../../../../../tools/client';

import {
  Container,
  FieldGroup,
  FieldSection,
  Label,
  Input,
  ButtonRow,
  Button,
  Toggle,
  Description
} from '../../configuration-sections.styles';

const client = new Client();

const DeliveryInsuranceConfigurationDisplay = () => {
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({});

  useEffect(() => {
    const fetchConfig = async () => {
      const res = await client.setup();
      const config = res.configuration?.shop?.deliveryInsurance || {};
      setForm({
        active: config.active === 'true' || config.active === true,
        price: config.price || '',
        description: config.description || '',
      });
      setLoading(false);
    };
    fetchConfig();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleToggle = () => {
    setForm({ ...form, active: !form.active });
  };

  const handleSave = async () => {
    await client.updateConfigurationByKey('shop.deliveryInsurance.active', { value: form.active.toString() });
    await client.updateConfigurationByKey('shop.deliveryInsurance.price', { value: form.price });
    await client.updateConfigurationByKey('shop.deliveryInsurance.description', { value: form.description });
    setEditing(false);
  };

  if (loading) return <Spinner />;

  return (
    <Container>
      <FieldSection>
        <FieldGroup>
          <Label htmlFor="active">Enable Delivery Insurance</Label>
          <Description>
            Toggle whether customers can opt into delivery insurance during checkout.
          </Description>
          <Toggle>
            <input
              type="checkbox"
              name="active"
              checked={form.active}
              onChange={handleToggle}
              disabled={!editing}
            />
            <span />
          </Toggle>
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="price">Insurance Price (in cents)</Label>
          <Description>
            This is the cost added to the order when a customer selects delivery insurance.
          </Description>
          <Input
            name="price"
            type="number"
            value={form.price}
            onChange={handleChange}
            disabled={!editing}
          />
        </FieldGroup>

        <FieldGroup>
          <Label htmlFor="description">Insurance Description</Label>
          <Description>
            This message is shown to the customer as a summary of what delivery insurance includes.
          </Description>
          <Input
            name="description"
            value={form.description}
            onChange={handleChange}
            disabled={!editing}
          />
        </FieldGroup>
      </FieldSection>

      <ButtonRow>
        {editing ? (
          <>
            <Button onClick={() => setEditing(false)}>Cancel</Button>
            <Button primary onClick={handleSave}>Save</Button>
          </>
        ) : (
          <Button primary onClick={() => setEditing(true)}>Edit</Button>
        )}
      </ButtonRow>
    </Container>
  );
};

export default DeliveryInsuranceConfigurationDisplay;